import React from 'react';
import { useIntl } from '@kyruus/intl';
import { object } from 'prop-types';

import { getLocationDisplayAddress } from './LocationProfile/utils';
import { getHeroImage } from './HeroImage/utils';
import { buildLocationCanonicalURL } from '../utils/location';
import { DEFAULT_LOCALE, getConfigProperty } from 'Common/config';
import { messages } from 'Src/shared/messages';
import { IntlHelmet } from 'Src/utils/intl-helmet';

export const Meta = ({ config = {}, locationData }) => {
  const intl = useIntl();

  const {
    name,
    address,
    specialties = [],
    services = [],
    media,
    location_type
  } = locationData;

  const locale = getConfigProperty(config, 'locale') || DEFAULT_LOCALE;
  const primaryDomain = getConfigProperty(config, 'primary_domain');
  const host = getConfigProperty(config, 'host');

  const specialtyNames = specialties.map(({ name }) => name).join(', ') || '';
  const serviceNames = services.map(({ name }) => name).join(', ') || '';

  const title = intl.formatMessage(messages.metaLocationTitle, {
    name,
    city: address.city,
    state: address.state,
    locationType: location_type?.name
  });
  const descriptionMessage = intl.formatMessage(
    messages.metaLocationDescription,
    {
      name,
      address: getLocationDisplayAddress(address),
      locationType: location_type?.name,
      serviceNames,
      specialtyNames
    }
  );
  const url = buildLocationCanonicalURL(primaryDomain || host, locationData);
  const heroImage = getHeroImage(media);

  const meta = [
    { name: 'description', content: descriptionMessage },
    { property: 'og:title', content: title },
    { property: 'og:locale', content: locale },
    {
      name: 'description',
      property: 'og:description',
      content: descriptionMessage
    },
    { name: 'url', property: 'og:url', itemprop: 'url', content: url },
    { property: 'og:type', content: 'profile' },
    ...(heroImage ? [{ property: 'og:image', content: heroImage }] : [])
  ];

  return (
    <IntlHelmet
      title={title}
      meta={meta}
      link={[{ rel: 'canonical', href: url }]}
    />
  );
};

Meta.propTypes = {
  config: object.isRequired,
  locationData: object.isRequired
};

export default Meta;
